module.exports = __webpack_public_path__ + "icons.b87b9ba532ace76ae9f6.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/icons.ttf
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/icons.ttf
// module chunks = styles